/* global axios */
import ApiClient from './ApiClient';

class AiAgentsAPI extends ApiClient {
  constructor() {
    super('ai_agents', { accountScoped: true });
  }

  documentsUrl(id) {
    return `${this.url}/${id}/documents`;
  }

  getDocuments(id) {
    return axios.get(this.documentsUrl(id));
  }

  createDocument(id, data) {
    return axios.post(this.documentsUrl(id), data);
  }

  updateDocument(aiAgentId, id, data) {
    return axios.patch(`${this.documentsUrl(aiAgentId)}/${id}`, data);
  }

  deleteDocument(aiAgentId, id) {
    return axios.delete(`${this.documentsUrl(aiAgentId)}/${id}`);
  }

  inboxesUrl(id) {
    return `${this.url}/${id}/inboxes`;
  }

  getInboxes(id) {
    return axios.get(this.inboxesUrl(id));
  }

  addInbox(id, data) {
    return axios.post(this.inboxesUrl(id), data);
  }

  removeInbox(id, relationId) {
    return axios.delete(`${this.inboxesUrl(id)}/${relationId}`);
  }

  playground(id, message, history = []) {
    return axios.post(`${this.url}/${id}/playground`, { message, history });
  }

  verifyToken(id, token, provider = 'openai') {
    return axios.post(`${this.url}/${id}/verify_token`, {
      api_token: token,
      provider,
    });
  }

  productsUrl(id) {
    return `${this.url}/${id}/products`;
  }

  getProducts(id) {
    return axios.get(this.productsUrl(id));
  }

  createProduct(id, data) {
    return axios.post(this.productsUrl(id), data);
  }

  updateProduct(aiAgentId, id, data) {
    return axios.patch(`${this.productsUrl(aiAgentId)}/${id}`, data);
  }

  deleteProduct(aiAgentId, id) {
    return axios.delete(`${this.productsUrl(aiAgentId)}/${id}`);
  }

  searchProducts(id, query) {
    return axios.get(`${this.productsUrl(id)}/search`, {
      params: { q: query },
    });
  }

  getCatalogSchema(id) {
    return axios.get(`${this.productsUrl(id)}/catalog_schema`);
  }
}

export default new AiAgentsAPI();
